import { jsPDF } from "jspdf";
import { getLessonQuiz } from "@/data/quizzes";
import { saveBlob } from "@/utils/pdfExport";

const clean = (s) =>
  String(s)
    .replace(/[−–—]/g, "-")
    .replace(/≈/g, "~")
    .replace(/→/g, "->")
    .replace(/[“”]/g, '"')
    .replace(/[‘’]/g, "'")
    .replace(/…/g, "...");

const LETTERS = ["A", "B", "C", "D"];

async function loadLogo() {
  try {
    const blob = await (await fetch("/icon-192.png")).blob();
    return await new Promise((res) => {
      const r = new FileReader();
      r.onload = () => res(r.result);
      r.onerror = () => res(null);
      r.readAsDataURL(blob);
    });
  } catch {
    return null;
  }
}

function header(pdf, logo, title, sub) {
  const W = pdf.internal.pageSize.getWidth();
  pdf.setFillColor(10, 10, 10);
  pdf.rect(0, 0, W, 24, "F");
  if (logo) pdf.addImage(logo, "PNG", 12, 5, 14, 14);
  pdf.setTextColor(245, 165, 36);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(15);
  pdf.text("DSLR Advisor", logo ? 30 : 12, 12);
  pdf.setTextColor(200, 200, 200);
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(9.5);
  pdf.text(clean(sub), logo ? 30 : 12, 18);
  pdf.setTextColor(255, 255, 255);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(11);
  pdf.text(clean(title), W - 12, 14, { align: "right" });
}

function footer(pdf) {
  const W = pdf.internal.pageSize.getWidth();
  const H = pdf.internal.pageSize.getHeight();
  pdf.setDrawColor(245, 165, 36);
  pdf.line(12, H - 12, W - 12, H - 12);
  pdf.setTextColor(120, 120, 120);
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(8);
  pdf.text("dslradvisor.com", 12, H - 7);
}

export async function downloadQuizPDF(path, lessonTitle, lang) {
  return buildQuizPDF(getLessonQuiz(path, lang), lessonTitle, `dslr-advisor-quiz-${path.replace(/\//g, "")}-${lang}.pdf`, lang);
}

export async function buildQuizPDF(qs, lessonTitle, filename, lang) {
  const es = lang === "es";
  const logo = await loadLogo();
  const pdf = new jsPDF({ unit: "mm", format: "letter" });
  const W = pdf.internal.pageSize.getWidth();
  const H = pdf.internal.pageSize.getHeight();
  const maxW = W - 30;

  header(pdf, logo, es ? "Cuestionario" : "Lesson Quiz", lessonTitle);
  pdf.setTextColor(40, 40, 40);
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(10);
  pdf.text(es ? "Nombre: ______________________________" : "Name: ______________________________", 12, 34);
  pdf.text(es ? "Fecha: ____________" : "Date: ____________", 120, 34);
  pdf.text(es ? `Puntaje: ____ / ${qs.length}` : `Score: ____ / ${qs.length}`, W - 12, 34, { align: "right" });
  pdf.setFontSize(9);
  pdf.setTextColor(110, 110, 110);
  pdf.text(es ? "Encierra en un círculo la letra de la respuesta correcta." : "Circle the letter of the correct answer.", 12, 41);

  let y = 51;
  qs.forEach((q, n) => {
    const qLines = pdf.splitTextToSize(clean(`${n + 1}. ${q.q}`), maxW);
    const optLines = q.o.map((o, i) => pdf.splitTextToSize(clean(`${LETTERS[i]})  ${o}`), maxW - 8));
    const need = qLines.length * 5.5 + optLines.reduce((s, l) => s + l.length * 5 + 1.5, 0) + 6;
    if (y + need > H - 18) {
      footer(pdf);
      pdf.addPage();
      header(pdf, logo, es ? "Cuestionario" : "Lesson Quiz", lessonTitle);
      y = 36;
    }
    pdf.setTextColor(20, 20, 20);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(11);
    pdf.text(qLines, 12, y);
    y += qLines.length * 5.5 + 1;
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(10.5);
    pdf.setTextColor(50, 50, 50);
    optLines.forEach((l) => {
      pdf.text(l, 20, y);
      y += l.length * 5 + 1.5;
    });
    y += 5;
  });
  footer(pdf);

  pdf.addPage();
  header(pdf, logo, es ? "Clave de Respuestas" : "Answer Key", `${lessonTitle} · ${es ? "para el profesor" : "for the teacher"}`);
  y = 36;
  qs.forEach((q, n) => {
    const ans = pdf.splitTextToSize(clean(`${n + 1}. ${LETTERS[q.a]})  ${q.o[q.a]}`), maxW);
    const why = pdf.splitTextToSize(clean(q.w), maxW - 6);
    if (y + ans.length * 5.5 + why.length * 4.8 + 6 > H - 18) {
      footer(pdf);
      pdf.addPage();
      header(pdf, logo, es ? "Clave de Respuestas" : "Answer Key", lessonTitle);
      y = 36;
    }
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(11);
    pdf.setTextColor(20, 20, 20);
    pdf.text(ans, 12, y);
    y += ans.length * 5.5;
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(9.5);
    pdf.setTextColor(100, 100, 100);
    pdf.text(why, 18, y);
    y += why.length * 4.8 + 6;
  });
  footer(pdf);

  saveBlob(pdf.output("blob"), filename);
}
